import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Navbar, scrollToHash } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { Hero } from "../sections/Hero";
import { Trust } from "../sections/Trust";
import { About } from "../sections/About";
import { Products } from "../sections/Products";
import { Wholesale } from "../sections/Wholesale";
import { Process } from "../sections/Process";
import { WhyPisi } from "../sections/WhyPisi";
import { Contact } from "../sections/Contact";

export default function HomePage() {
    const location = useLocation();
    const [presetType, setPresetType] = useState("");

    useEffect(() => {
        document.title = "PISI LIMITED | Wholesale & Retail Products in the UK";
    }, []);

    useEffect(() => {
        if (location.hash) {
            const timer = setTimeout(() => scrollToHash(location.hash), 100);
            return () => clearTimeout(timer);
        }
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <div data-testid="home-page">
            <Navbar />
            <main>
                <Hero />
                <Trust />
                <About />
                <Products />
                <Wholesale onWholesaleEnquiry={() => setPresetType("Wholesale Enquiry")} />
                <Process />
                <WhyPisi />
                <Contact presetType={presetType} />
            </main>
            <Footer />
        </div>
    );
}
